
oneyMarketing = {
    root: '/oney/simulations',
    urlForProduct: '/oney/simulations/product/',
    urlForBundle: '/oney/simulations/bundle/',
    urlForCart: '/oney/simulations/cart',
    isLoading:false,
    displaySimulation: function (element) {
        if(oneyMarketing.isLoading) return ;
        oneyMarketing.isLoading=true;
        var url,
            source = $(element).data("source");

        switch (source) {
            case 'product':
                var productCode = $(element).data("productCode");
                if (productCode === undefined) {
                    return false;
                }
                url = oneyMarketing.urlForProduct + productCode;
                break;
            case 'bundle':
                var bundleId = $(element).data("bundleId");
                if (bundleId === undefined) {
                    return false;
                }
                url = oneyMarketing.urlForBundle + bundleId;
                break;
            case 'cart':
                url = oneyMarketing.urlForCart;
                break;
            default:
                return false;
        }
        $.ajax({
            url: url
        }).done(function (html) {
            $("#oneyModal .modal-body").html(html);
            oneyMarketing.disableScroll();
            $("#oneyModal").show();
            $("#oneyModal").modal();
            oneyMarketing.isLoading=false;
        }).fail(function (html) {
            console.log("ERROR !!");
            oneyMarketing.isLoading=false;
        });
    },
    bindOneyModalEvents:function bindOneyModalEvents(){
        var active_tab;
        var active_menu;
        var active_mobile_menu;
        $("#oneyModal").on("hidden.bs.modal", function () {
            active_tab=null;
            active_menu=null;
            active_mobile_menu=null;
        });
      $("#oneyModal").on("click",".tab-mobile",function(e){
       e.currentTarget.classList.toggle("active");
       var tab=e.currentTarget.getAttribute("rel");
       var new_tab=document.querySelector("#tab"+tab);
       if(active_tab){
         if(new_tab != active_tab){
          active_tab.classList.remove("active");
         }
       }
       if(!active_tab) {
        if ($(".tab-container .content").first()[0] !== new_tab) {
            $(".tab-container .content").first().removeClass("active");
            new_tab.classList.toggle("active");
              }
        else new_tab.classList.toggle("active");
        active_tab=new_tab;
          return;
       }
      active_tab=new_tab;
     new_tab.classList.toggle("active");
            })
      $("#oneyModal").on("click",".tab-desktop",function(e){
        if(e.currentTarget != active_menu){
            $(".tab-desktop.active").removeClass("active");
         }
         if(active_menu && e.currentTarget != active_menu){
         }
         if(!active_menu && !active_tab){
             $(".tab-desktop[rel='0']").removeClass("active");
             $(".tab-container .content").first().removeClass("active");
         }
         e.currentTarget.classList.add("active");
         active_menu= e.currentTarget;
         if(active_tab){
           if(active_tab == e.target) return;
           active_tab.classList.remove('active');
         }
         var tab=e.target.getAttribute("rel");
         document.querySelector("#tab"+tab).classList.add("active");
         active_tab=document.querySelector("#tab"+tab); 
        })

        $("#oneyModal").click(function(event){
           // event.stopPropagation();
            if(event.target == event.currentTarget) $("#oneyModal").modal("hide");
        })

            /* reset variables and enable scroll after modal close */

        $("#oneyModal").on('click','.close',function(){
            active_tab=null;
            active_menu=null;
            active_mobile_menu=null;
            oneyMarketing.enableScroll();
            });
            var targetNode = document.getElementById('oneyModal');
            var config = { attributes: true};
            var observerCallback= function(mutationsList, observer) {
                mutationsList.forEach(function(mutation){
                    if (mutation.attributeName === "style") {
                        var target_style = mutation.target.style.display;
                        if(target_style === "none"){
                        active_tab=null;
                        active_menu=null;
                        active_mobile_menu=null;
                        oneyMarketing.enableScroll();
                        }              
                }
                })
            };
            var modalObserver= new MutationObserver(observerCallback);
            modalObserver.observe(targetNode, config);
            },
        disableScroll:function disableScroll() {
            $("html").css({
                overflow: "hidden"
            })
        }
        ,
        enableScroll:function enableScroll() {
            $("html").css({
                overflow: "auto"
            })
        }
    };

$(document).on('click', '.js-oney-installment', function (e) {
    e.preventDefault();
    oneyMarketing.displaySimulation(this);
});
document.addEventListener("DOMContentLoaded", oneyMarketing.bindOneyModalEvents);
